module.exports = __webpack_public_path__ + "static/media/gifitingOption.28667727.png";